import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Fab = ({ href }: { href: string }) => (
  <Link
    className="text-gray-600 hover:text-sky-500 fixed bottom-8 right-1/2 translate-x-1/2 text-5xl bg-white rounded-full border border-white shadow shadow-gray-600"
    to={href}
  >
    <FontAwesomeIcon icon="circle-plus" />
  </Link>
);

export default Fab;
